<mwe-product-tariff-card-template
  [product]="product()"
  [headlineReference]="headlineService.getHeadline(0)"
  [hasContent]="false"
  data-test="tariff-card-stromrueck"
/>
